import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-enviroment",
  "use": "icon-enviroment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-enviroment\"><path d=\"M547.387733 384l61.824 16.5632-99.387733 370.9184-61.824-16.5632z\" p-id=\"3440\" /><path d=\"M128 64v896h768V64H128zM64 0h896v1024H64V0z\" p-id=\"3441\" /><path d=\"M128 192h768V256H128zM282.513067 583.765333l90.504533-90.513066L327.765333 448 214.6304 561.134933 192 583.765333l135.765333 135.765334 45.252267-45.252267L282.513067 583.765333zM757.0176 583.765333L666.513067 674.2784l45.252266 45.252267 113.134934-113.134934 22.6304-22.6304L711.765333 448l-45.252266 45.252267L757.0176 583.765333z\" p-id=\"3442\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/enviroment.svg
// module id = 9zXf
// module chunks = 77